const TopInfluencersReport = {
	
	visual: {
		icon: "va-icon fa fa-bar-chart",
		title: "Top Influential Accounts Report",
		desc: "List of most Influential accounts in twitter community"
	},

	binding: [
	{"account_limit": "number", "label":"Return limit"},
	{"status_created_at_from": "date", "label":"Influence period from"},
	{"status_created_at_to": "date", "label":"Influence period to"}
	],

	query:`CALL algo.betweenness.stream(
	  	"MATCH 
	  		(a:Account) 
	  	RETURN 
	  		id(a) as id",
	  	"MATCH 
	  		(a1:Account)-[:MENTIONED_BY]->(s:Status)<-[:POSTED|RETWEETED]-(a2:Account) 
	  	WHERE 
			date(s.created_at) >= date(':status_created_at_from') AND date(s.created_at) <= date(':status_created_at_to')
	  	RETURN 
	  		id(a1) as source, id(a2) as target",
	  	{
	  		graph:'cypher', 
	  		write: false
	  	}
	)
	YIELD 
		nodeId, centrality
	MATCH 
		(account:Account) WHERE id(account) = nodeId
	WITH 
		account AS user,centrality
	CALL 
		apoc.create.vNode(['influancer'],{node:user.screen_name,influance:centrality})
	YIELD 
		node as Influancer
	RETURN 
		Influancer
	ORDER BY centrality DESC LIMIT :account_limit;`,

	config:{
		console_debug:true,
		labels: {
			"influancer": {
				"caption": "node",
				"size":"influance"
			}
		}
	}

}

export default TopInfluencersReport;
